export default __webpack_public_path__ + "static/media/iconPolygonBlack.550d810a.svg";